import { useCallback } from "react";
import Cookies from "js-cookie";

interface IUseCookies {
    setTokens: (accessToken: string, refreshToken: string) => void;
    getTokens: () => { accessToken: string | null; refreshToken: string | null };
}

export const ACCESS_TOKEN_KEY = "token";
export const REFRESH_TOKEN_KEY = "refresh_token";

export const COOKIE_OPTIONS = {
    domain: ".boomform.com",
    path: "/",
    secure: true,
};

export const useCookies = (): IUseCookies => {
    const setTokens = useCallback((accessToken: string, refreshToken: string) => {
        Cookies.set(ACCESS_TOKEN_KEY, accessToken, {
            ...COOKIE_OPTIONS,
            expires: 7,
        });

        Cookies.set(REFRESH_TOKEN_KEY, refreshToken, {
            ...COOKIE_OPTIONS,
            expires: 30,
        });
    }, []);

    const getTokens = useCallback(() => {
        const accessToken = Cookies.get(ACCESS_TOKEN_KEY) || null;
        const refreshToken = Cookies.get(REFRESH_TOKEN_KEY) || null;
        return { accessToken, refreshToken };
    }, []);

    return { setTokens, getTokens };
};

export default useCookies;
